import React, { useState, useEffect } from "react";
import { Box, Typography, Paper } from "@mui/material";

const Forbidden = () => {
	const [countdown, setCountdown] = useState(5);

	useEffect(() => {
		const timer = setInterval(() => {
			setCountdown((prev) => {
				if (prev <= 1) {
					clearInterval(timer);
					window.location.href = "/";
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(timer);
	}, []);

	return (
		<Box
			sx={{
				minHeight: "85vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				padding: 2,
				width: "100vw",
				background: (theme) => `linear-gradient(249deg, ${theme.palette.background.default} 0%, #FFFFFF 100%)`,
			}}
		>
			<Paper
				elevation={0}
				sx={{
					p: 6,
					textAlign: "center",
					borderRadius: 3,
					maxWidth: 600,
					width: "100%",
					bgcolor: "background.paper",
				}}
			>
				<Box sx={{ mb: 4 }}>
					<Typography
						variant="h1"
						sx={{
							fontSize: { xs: "4rem", md: "6rem" },
							fontWeight: 700,
							color: "error.light",
							mb: 2,
						}}
					>
						403
					</Typography>
					<Typography
						variant="h4"
						sx={{
							fontWeight: 600,
							color: "text.primary",
							mb: 3,
						}}
					>
						Access denied...
					</Typography>
				</Box>

				<Box sx={{ mb: 4 }}>
					<Typography
						variant="h6"
						sx={{
							color: "text.secondary",
							mb: 2,
							fontWeight: 500,
						}}
					>
						You don't have permission to access this page.
					</Typography>
				</Box>

				<Box
					sx={{
						p: 3,
						backgroundColor: "info.verylight",
						borderRadius: 2,
						border: "1px solid",
						borderColor: "info.light",
					}}
				>
					<Typography
						variant="h6"
						sx={{
							color: "primary.dark",
							fontWeight: 600,
							mb: 1,
						}}
					>
						Redirecting to home page in {countdown} seconds...
					</Typography>
					<Typography
						variant="body2"
						sx={{
							color: "text.secondary",
						}}
					>
						You will be automatically redirected to the home page shortly.
					</Typography>
				</Box>
			</Paper>
		</Box>
	);
};

export default Forbidden;
